/**
 * SatPhonePanel — Satellite Phones panel.
 *
 * Thin wrapper around ItemSection with the sat phone image and 4-column grid.
 */
import { useDesktopStore } from '../../stores/desktop'
import { SAT_PHONE_ICON } from '../../assets'
import ItemSection from './ItemSection'

export default function SatPhonePanel() {
  const { satPhones, setSatPhones } = useDesktopStore()
  return (
    <ItemSection
      items={satPhones}
      setItems={setSatPhones}
      title="Satellite Phone"
      image={SAT_PHONE_ICON}
      itemLabel="Phone"
      cols={4}
    />
  )
}
